import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { from, Observable, switchMap } from 'rxjs';

let inFlightRefresh: Promise<void> | null = null;

const isAuthlessUrl = (url: string): boolean =>
  url.includes('oauth2') ||
  url.includes('emea') ||
  url.endsWith('/api/translations');

const ensureFreshToken = (oauth: OAuthService): Promise<void> => {
  if (oauth.hasValidAccessToken()) {
    return Promise.resolve();
  }
  inFlightRefresh ??= oauth
    .silentRefresh(undefined, true)
    .then(() => undefined)
    .catch(() => undefined)
    .finally(() => {
      inFlightRefresh = null;
    });
  return inFlightRefresh;
};

export const tokenValidityInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  if (isAuthlessUrl(req.url)) {
    return next(req);
  }
  const oauth = inject(OAuthService);
  if (oauth.hasValidAccessToken() || !oauth.getAccessToken()) {
    return next(req);
  }
  return from(ensureFreshToken(oauth)).pipe(switchMap(() => next(req)));
};
